import {Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FileFormatService} from "../../../assets-library/services/fileformat.service";
import {RolesService} from "../../../../core/services/roles/roles.service";
import {MatTableDataSource} from "@angular/material/table";
import {ActiveAction} from "../../services/collection.model";
import {MatDialog} from "@angular/material/dialog";
import {DeleteCollectionComponent} from '../delete-collection/delete-collection.component';
import { CollectionService } from '../../services/collection.service';
import { CollectionItem, ReportType } from '../../services/collection.model';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import find from 'lodash/find';
import { MatSort } from '@angular/material/sort';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
@Component({
  selector: 'app-collections-table',
  templateUrl: './collections-table.component.html',
  styleUrls: ['./collections-table.component.scss']
})
export class CollectionsTableComponent implements OnInit, OnChanges {

  collectionList: MatTableDataSource<CollectionItem>;
  defaultTableColumns: string[] = ['collectionName', 'reportType'];
  tableColumnsWithActions: string[] = [...this.defaultTableColumns, 'actions'];
  displayedColumns: string[] = this.tableColumnsWithActions;
  collectionStatus: string = 'loading';
  canEdit: any;
  searchValue: string = "";
  savingInProgress: boolean;
  showToast: boolean;
  toastType: string = "";
  toastTitle: string = "";
  toastMessage: string = "";
  assets : CollectionItem[];
  name = '';
  updateCollectionForm: FormGroup;
  activeAction: ActiveAction = {
    id: null,
    action: null,
    item: null,
  };
  canRename = true
  @Input() searchCollection: string;
  @Input() canEditCollections: boolean;
  @Input() canSelect: boolean;
  @Input() collectionCurrentStatus: string;
  @Input() filters: string[];

  @ViewChild(MatSort) sort: MatSort;

  constructor(
      private http: HttpClient,
      private fileFormatService: FileFormatService,
      private rolesService: RolesService,
      private dialog: MatDialog,
      private collectionService: CollectionService,
  ) {
    this.collectionList = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.checkTableColumns();
    this.collectionList = new MatTableDataSource(this.assets);
    this.loadCollections();

    this.collectionService.showToaster.subscribe(data => {
      if(data.type === 'success') {
        this.loadCollections();
      }
      this.showToast = true;
      this.toastType = data.type;
      this.toastTitle = data.title;
      this.toastMessage = data.message;
      setTimeout(() => { this.resetToaster() }, 1500);
    });

    this.updateCollectionForm = new FormGroup({
      name: new FormControl('', [Validators.required], this.checkValidName.bind(this)),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filters) {
      if(changes.filters.previousValue !== changes.filters.currentValue && changes.filters.currentValue.length > 0) {
        this.filters = changes.filters.currentValue;
        const filteredCollections = this.assets.filter(filter => this.filters.includes(filter.featureType));
        this.collectionList = new MatTableDataSource(filteredCollections);
      } else {
        this.collectionList = new MatTableDataSource(this.assets);
      }
    }

    if(changes.searchCollection) {
      if(changes.searchCollection.previousValue !== changes.searchCollection.currentValue) {
        this.searchCollection = changes.searchCollection.currentValue;
        this.applySearch();
      }
    }
  }

  loadCollections() {
    this.collectionService.getCollections().subscribe((response) => {
      this.collectionStatus = 'loaded';
      const collections = sortBy(response, item => {
        return item.featureName.toLowerCase();
      }) as CollectionItem[];
      this.assets = collections.filter(collection => !collection.disabled).map((collection) => {
        return {
          ...collection,
          featureType: ReportType[collection.featureType.trim()]
        }
      });
      this.collectionList = new MatTableDataSource(this.assets);
      this.collectionList.sort = this.sort;
    });
  }

  applySearch() {
    if (this.searchCollection) {
      this.collectionList.data = this.assets;
    }

    if(this.filters && this.filters.length > 0) {
      this.collectionList.data = this.assets.filter(filter => this.filters.includes(filter.featureType));
    }

    this.collectionList.filterPredicate = (data, filter: string): boolean => {
      return (
          this.checkProperty(data.featureName).toLowerCase().includes(filter) ||
          this.checkProperty(data.featureType).toLowerCase().includes(filter)
      );
    };
    this.collectionList.filter = this.searchCollection.trim().toLowerCase();
  }

  checkProperty(property) {
    return property ? property : '';
  }


  checkTableColumns() {
    this.displayedColumns = this.tableColumnsWithActions;
  }

  setActiveStyles(action: string, id: string) {
    return this.isActiveAction(action, id) ? 'active' : '';
  }

  isActiveAction(action: string, id: string) {
    return this.activeAction.action === action && this.activeAction.id === id;
  }

  onMatSortChange() {
    if (this.sort) {
      const { active, direction } = this.sort;
      this.assets = sortBy(this.assets, item => {
        if(active === 'collectionName') {
          return item.featureName
              ? item.featureName.toLowerCase()
              : ''
        } else if (active === 'reportType') {
          return item.featureType
              ? item.featureType.toLowerCase()
              : ''
        } else {
          return item[active];;
        }
      });

      if (direction === 'desc') {
        this.assets = reverse(this.assets);
      }
    }

    this.collectionList.data = this.assets;
  }

  deleteCollection(collection: any) {
    const dialogRef = this.dialog.open(DeleteCollectionComponent, {
      'data': collection
    });
  }

  resetToaster() {
    this.showToast = false;
    this.toastType = "";
    this.toastTitle = "";
    this.toastMessage = "";
  }

  checkValidName(control: AbstractControl) {
    const duplicate = find(this.collectionList.data, { featureName: control.value });
    return new Promise((resolve) => {
      if (duplicate && duplicate.featureUUID !== this.activeAction.id) {
        resolve({ nameError: 'Collection name already in use' });
      } else if (control.value.length > 255) {
        resolve({ nameError: 'Max 255 characters limit exceeded.' });
      }
      resolve(null);
    });
  }

  getValidationError() {
    const name = this.updateCollectionForm.get('name');
    if (name && name.errors && name.errors.required) {
      return 'Name is required';
    } else if (name && name.errors && name.errors.pattern) {
      return 'No spaces or special characters allowed';
    } else if (name && name.errors && name.errors.nameError) {
      return name.errors.nameError;
    }
    return 'Validation Error!';
  }

  editName(id: string, name: string, e: Event) {
    e.stopPropagation();
    this.name = name;
    this.updateCollectionForm.setValue({ name });
    this.setActiveAction('edit', id);
    this.canRename = false;
  }

  setActiveAction(action: string, id: string) {
    this.activeAction = {
      action,
      id,
      item: null,
    };
    console.log('Active action', this.activeAction)
  }

  clearActiveAction() {
    this.activeAction = {
      action: null,
      id: null,
      item: null,
    };
  }

  selectCollection(id: string) {
    if (this.canSelect) {
      if (this.activeAction.id === id) {
        this.clearActiveAction();
      } else {
        this.activeAction = {
          action: 'selected',
          id,
          item: find(this.collectionList.data, { featureUUID: id }),
        };
      }
    }
  }

  canEditAssets() {
    return this.rolesService.canEditAssets();
  }

  checkCanRename(id: string) {
    return this.canEditAssets() ? !this.isActiveAction('edit', id) : true;
  }

  save(e, collection: any) {
    e.stopPropagation();
    this.savingInProgress = true;
    const newName = this.updateCollectionForm.get('name').value;
    const updatedCollection = {
      ...collection,
      featureName: newName,
      featureType: this.collectionService.getFeatureType(collection.featureType)
    }
    this.collectionService.updateCollection(updatedCollection)
        .subscribe((isSuccessful) => {
          this.savingInProgress = false;
          if (isSuccessful) {
            this.clearActiveAction();
            this.collectionService.showToast({
              type: 'success',
              title: 'Collection Saved',
              message: `${collection.featureType} collection "${newName}" successfully saved.`
            });
          } else {
            this.collectionService.showToast({
              type: 'error',
              title: 'Collection Not Saved',
              message: `${collection.featureType} collection "${newName}" not saved.`
            });
          }
        });
    this.canRename = true;
  }

  cancel(e){
    e.stopPropagation();
    this.clearActiveAction();
    this.canRename = true;
  }
}
